<template>
  <div class="policy-page">
    <div class="policy-container">
      <header class="policy-header">
        <h1 class="policy-title">
          Политика в отношении обработки персональных данных
        </h1>
        <p class="policy-subtitle">
          МБОУ СОШ № 24 имени генерала Н.Н. Раевского ·
          <span>actsch24.ru</span> / <span>act24server.ru</span>
        </p>
      </header>

      <section class="policy-section">
        <h2>1. Общие положения</h2>
        <p>
          1.1. Настоящая Политика определяет порядок обработки персональных
          данных пользователей внутреннего веб-сервиса Школы, доступного по
          адресу
          <a href="https://actsch24.ru/" target="_blank" rel="noopener"
            >actsch24.ru</a
          >
          (далее — Сервис), размещённого на серверной инфраструктуре
          <a href="https://act24server.ru/" target="_blank" rel="noopener"
            >act24server.ru</a
          >.
        </p>
        <p>
          1.2. Оператор персональных данных —
          <strong>МБОУ СОШ № 24 имени генерала Н.Н. Раевского</strong>
          (ИНН 2315078269, ОГРН 1022302387909; 353983, Краснодарский край, г.
          Новороссийск, ст. Раевская, ул. Красная, д. 40). (далее Школа)
        </p>
        <p>
          1.3. Политика разработана в соответствии с Федеральным законом от
          27.07.2006 № 152-ФЗ «О персональных данных».
        </p>
      </section>

      <section class="policy-section">
        <h2>2. Цели обработки</h2>
        <p>
          2.1. Сервис <strong>actsch24.ru</strong> — внутренний инструмент
          Школы. Персональные данные обрабатываются исключительно для:
        </p>
        <ul>
          <li>
            идентификации пользователей (ученик / сотрудник / администратор);
          </li>
          <li>отображения данных в интерфейсе Сервиса;</li>
          <li>обеспечения работы Сервиса и технической поддержки.</li>
        </ul>
        <p class="policy-note">
          2.2. Сервис <strong>не используется</strong> для публикации данных в
          открытом доступе, рекламы или передачи третьим лицам.
        </p>
      </section>

      <section class="policy-section">
        <h2>3. Категории субъектов и состав данных</h2>
        <div class="policy-table">
          <div class="policy-row">
            <div class="policy-cell policy-cell--key">Обучающиеся</div>
            <div class="policy-cell">Фамилия и имя</div>
          </div>
          <div class="policy-row">
            <div class="policy-cell policy-cell--key">
              Иные пользователи<br /><small
                >(сотрудники, родители, администраторы)</small
              >
            </div>
            <div class="policy-cell">ФИО</div>
          </div>
          <div class="policy-row">
            <div class="policy-cell policy-cell--key">Технические данные</div>
            <div class="policy-cell">
              IP-адрес, данные браузера, cookie (для сессии и авторизации на
              act24server.ru)
            </div>
          </div>
        </div>
      </section>

      <section class="policy-section">
        <h2>4. Правовые основания</h2>
        <ul>
          <li>Устав Школы и локальные акты об использовании внутренних ИС;</li>
          <li>согласие субъекта (если требуется);</li>
          <li>Федеральный закон № 152-ФЗ.</li>
        </ul>
      </section>

      <section class="policy-section">
        <h2>5. Порядок и условия обработки</h2>
        <p>
          5.1. Обработка осуществляется с использованием средств автоматизации
          (сервер <strong>act24server.ru</strong>).
        </p>
        <p>
          5.2. <strong>Передача третьим лицам:</strong> персональные данные не
          передаются. Исключение — техническое обеспечение работы
          хостинга/сервера act24server.ru, если он не в прямом управлении Школы
          (поставщик действует по поручению Оператора и обязан соблюдать
          конфиденциальность).
        </p>
        <p>
          5.3. <strong>Сроки хранения:</strong> в течение срока, необходимого
          для функционирования Сервиса, либо до отзыва согласия, либо до
          удаления учётной записи.
        </p>
        <p>
          5.4. <strong>Cookie:</strong> используются исключительно для
          авторизации и корректной работы интерфейса. Отключение cookie в
          браузере может сделать Сервис недоступным.
        </p>
      </section>

      <section class="policy-section">
        <h2>6. Меры по защите</h2>
        <ul>
          <li>
            доступ к Сервису и базе данных ограничен кругом лиц, определённых
            администратором Школы;
          </li>
          <li>
            соединение с actsch24.ru и act24server.ru защищено протоколом HTTPS;
          </li>
          <li>пароли и учётные данные не отображаются в открытом виде.</li>
        </ul>
      </section>

      <section class="policy-section">
        <h2>7. Права субъектов</h2>
        <p>7.1. Субъект (или его законный представитель) вправе запросить:</p>
        <ul>
          <li>подтверждение факта обработки его данных в Сервисе;</li>
          <li>
            уточнение или удаление данных (если это не противоречит технической
            необходимости работы Сервиса).
          </li>
        </ul>
        <p>
          7.2. Обращения принимаются по официальным контактам Школы:
          <a href="tel:88617797008">8 (8617) 79-70-08</a>,
          <a href="mailto:moysh24@mail.ru">moysh24@mail.ru</a>.
        </p>
      </section>

      <section class="policy-section">
        <h2>8. Заключительные положения</h2>
        <p>
          8.1. Политика размещается по адресу
          <strong>actsch24.ru/policy</strong> и может быть изменена Школой.
          Актуальная версия всегда доступна по этому адресу.
        </p>
      </section>

      <footer class="policy-footer">
        <router-link to="/" class="policy-back">← На главную</router-link>
        <span class="policy-date">Обновлено: {{ today }}</span>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: "Policy",
  computed: {
    today() {
      const d = new Date();
      const pad = (n) => String(n).padStart(2, "0");
      return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()}`;
    },
  },
};
</script>

<style scoped>
.policy-page {
  min-height: 100vh;
  background: #f5f6f8;
  padding: 24px 16px 48px;
  box-sizing: border-box;
}

.policy-container {
  max-width: 820px;
  margin: 0 auto;
  background: #fff;
  border-radius: 10px;
  padding: 28px 36px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  color: #2b2b2b;
  line-height: 1.55;
  font-size: 14.5px;
}

/* Заголовок */
.policy-header {
  padding-bottom: 14px;
  margin-bottom: 18px;
  border-bottom: 1px solid #e5e7eb;
}

.policy-title {
  margin: 0 0 6px;
  font-size: 22px;
  line-height: 1.25;
  font-weight: 700;
  color: #1a1a1a;
}

.policy-subtitle {
  margin: 0;
  color: #6b7280;
  font-size: 13px;
}

.policy-subtitle span {
  color: #2563eb;
  font-weight: 500;
}

/* Секции */
.policy-section {
  margin-bottom: 16px;
}

.policy-section:last-of-type {
  margin-bottom: 0;
}

h2 {
  font-size: 16px;
  margin: 0 0 6px;
  color: #0048ac;
  font-weight: 600;
}

p {
  margin: 0 0 6px;
}

ul {
  margin: 0 0 6px;
  padding-left: 0; /* Убираем стандартный отступ, сделаем свой */
  list-style: none; /* Убираем стандартные точки, чтобы не было дублей */
}

li {
  position: relative;
  padding-left: 18px; /* Место под тире */
  margin-bottom: 4px;
  display: block; /* Принудительно блочный */
}

/* Рисуем тире вручную через псевдоэлемент */
li::before {
  content: "—"; /* Длинное тире */
  position: absolute;
  left: 0;
  top: 0;
  color: #6b7280; /* Серый цвет, как в макете */
  font-weight: 400;
}
.policy-note {
  color: #4b5563;
  font-size: 13.5px;
}

/* Таблица категорий */
.policy-table {
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  overflow: hidden;
  margin-top: 4px;
}

.policy-row {
  display: flex;
  border-bottom: 1px solid #e5e7eb;
}

.policy-row:last-child {
  border-bottom: none;
}

.policy-cell {
  padding: 8px 12px;
  font-size: 14px;
  flex: 1;
}

.policy-cell--key {
  background: #f9fafb;
  font-weight: 600;
  color: #1f2937;
  flex: 0 0 42%;
  border-right: 1px solid #e5e7eb;
}

.policy-cell small {
  font-weight: 400;
  color: #6b7280;
  font-size: 12px;
}

/* Ссылки */
a {
  color: #2563eb;
  text-decoration: none;
  word-break: break-word;
}

a:hover {
  text-decoration: underline;
}

/* Футер */
.policy-footer {
  margin-top: 24px;
  padding-top: 14px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  color: #9ca3af;
}

.policy-back {
  color: #2563eb;
  font-weight: 500;
}

/* Адаптив */
@media (max-width: 640px) {
  .policy-page {
    padding: 12px 8px 32px;
  }
  .policy-container {
    padding: 20px 16px;
    border-radius: 8px;
    font-size: 14px;
  }
  .policy-title {
    font-size: 19px;
  }
  h2 {
    font-size: 15px;
  }
  .policy-row {
    flex-direction: column;
  }
  .policy-cell--key {
    flex: none;
    border-right: none;
    border-bottom: 1px solid #e5e7eb;
  }
  .policy-footer {
    flex-direction: column;
    gap: 6px;
    align-items: flex-start;
  }
}
</style>
